import React from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_vendora-os/artifacts/pwqbypxs_c95ab58d-87a7-4baa-ba81-1f6a714401b5.jpg";

export function Logo({ size = 36, withWordmark = true, className = "", inverted = false }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="vendora-logo">
      <img
        src={LOGO_URL}
        alt="Vendora"
        style={{ width: size, height: size, objectFit: "contain" }}
        className="rounded-sm"
      />
      {withWordmark && (
        <div className="flex flex-col leading-none">
          <span
            className={`font-display font-black text-xl tracking-tight ${inverted ? "text-white" : "text-primary"}`}
          >
            Vendora
          </span>
        </div>
      )}
    </div>
  );
}

export function WordmarkTagline({ inverted = false }) {
  const color = inverted ? "text-white/90" : "text-primary";
  return (
    <div className={`flex items-baseline gap-1.5 font-mono text-[10px] tracking-[0.25em] ${color}`}>
      <span>SOURCE.</span>
      <span style={{ color: "#F47A1F" }}>SELL.</span>
      <span style={{ color: "#2E5BFF" }}>SHIP.</span>
      <span style={{ color: "#2BA84A" }}>GROW.</span>
    </div>
  );
}
